import KakaoAddressSearch from '../../components/KakaoAddressSearch';
import AuthService from '../../api/service/auth/AuthService';
import SelectBox from '../../components/SelectBox';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { formatPhoneNumber } from '../../utils/formatPhoneNumber';
import { useNavigate } from 'react-router-dom';
import {
  LoginPageUrl,
  PrivacyInfoPageUrl,
  PrivacyPolicyPageUrl,
} from '../../url/poenUrl';
import CountdownTimer from '../../components/CountdownTimer';
import { formatBusinessNumber } from '../../utils/formatBusinessNumber';
import { formatAccountNumber } from '../../utils/formatAccountNumber';
import LoadingOverlay from '../../components/LoadingOverlay';
import PermissionRedirect from '../../components/PermissionRedirect';
import { signupFormState, SignupFormData } from '../../recoil/signupFormState';
import { useRecoilState, useResetRecoilState } from 'recoil';

const Container = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.whiteColor};
`;

const Title = styled.h1`
  padding: 30px 0px;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  color: ${({ theme }) => theme.colors.whiteColor};
  background-color: #d3e8e0;
  @media (max-width: 768px) {
    padding: 20px 0px;
    font-size: 20px;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 30px;
  max-width: 1024px;
  margin: 0 auto;
  border-radius: 10px;
  @media (max-width: 768px) {
    padding: 20px;
    gap: 15px;
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const SectionTitleContainer = styled.div`
  margin: 10px 0px;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

const Line = styled.div`
  flex: 1;
  height: 1px;
  background-color: #ddd;
`;

const StyledSectionTitle = styled.h2`
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: #333;
`;

const RowContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const RowBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media (max-width: 768px) {
    gap: 10px;
  }
`;
const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 15px;
  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  width: 170px;
  text-align: left;
  @media (max-width: 768px) {
    width: 100%;
    text-align: left;
  }
`;

const LabelNo = styled.label`
  width: 170px;

  @media (max-width: 768px) {
    display: none;
  }
`;
const LabelSecond = styled(Label)`
  width: 80px;
  @media (max-width: 768px) {
    width: 100%;
    text-align: left;
  }
`;

const Input = styled.input`
  flex: 1;
  padding: 10px;
  max-width: 300px;
  border: 1px solid ${({ theme }) => theme.colors.inputLine};
  background-color: ${({ theme }) => theme.colors.inputBG};
  border-radius: 6px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.mainColor};
  }
  @media (max-width: 768px) {
    max-width: 600px;
    min-width: 200px;
    width: 100%;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const CheckboxDetail = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 10px;
  background-color: #fafafa;
  border-radius: 10px;
`;

const CheckboxRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Checkbox = styled.input``;

const CheckboxText = styled.span`
  font-size: 14px;
`;

const CheckboxDetailText = styled.span`
  cursor: pointer;
  font-size: 14px;
  color: #d5d5d5;
  &:hover {
    text-decoration: underline;
  }
`;

const Button = styled.button`
  padding: 5px 10px;
  background-color: #aca7a4;
  color: white;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #9a9694;
  }
`;

const SiginUpButton = styled(Button)`
  padding: 10px 16px;
  background-color: ${({ theme }) => theme.colors.subColor};
  &:hover {
    background-color: ${({ theme }) => theme.colors.subHoverColor};
  }
`;

const ButtonM = styled(Button)`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;
const ButtonP = styled(Button)`
  display: block;
  @media (max-width: 768px) {
    display: none;
  }
`;

const SignupPage = () => {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState<'buyer' | 'seller'>('buyer'); // 기본값은 'buyer'
  const [identifierError, setIdentifierError] = useState<{
    message: string;
    color: string;
  }>({
    message: '',
    color: '',
  });

  const [isIdentifierChecked, setIsIdentifierChecked] = useState(false);

  const [passwordMatchError, setPasswordMatchError] = useState<string>(''); // 비밀번호 일치 여부 메시지 상태
  const [passwordError, setPasswordError] = useState<string>(''); // 비밀번호 오류 메시지 상태
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [targetTime, setTargetTime] = useState('false');

  const [formData, setFormData] =
    useRecoilState<SignupFormData>(signupFormState);
  const resetSignupForm = useResetRecoilState(signupFormState);

  const [bank, setBank] = useState(''); // 추가한 은행 선택 상태
  const [email, setEmail] = useState('');
  const [customEmail, setCustomEmail] = useState(''); // 직접 입력한 이메일을 관리하는 상태
  const [isEmailLoading, setIsEmailLoading] = useState(false);
  const [isValidated, setIsValidated] = useState(false); // 사업자 확인 상태 추가

  const [allChecked, setAllChecked] = useState(false); // 전체 동의
  const [termsChecked, setTermsChecked] = useState(false); // 이용약관 동의
  const [privacyChecked, setPrivacyChecked] = useState(false); // 개인정보 수집·이용 동의

  // 전체 동의 체크 변경 핸들러
  const handleAllAgreementChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setAllChecked(checked);
    setTermsChecked(checked);
    setPrivacyChecked(checked);
  };

  // 개별 체크 변경 핸들러
  const handleAgreementChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: string
  ) => {
    const checked = e.target.checked;

    if (type === 'terms') {
      setTermsChecked(checked);
    } else if (type === 'privacy') {
      setPrivacyChecked(checked);
    }
  };

  useEffect(() => {
    if (termsChecked && privacyChecked) {
      setAllChecked(true);
    } else {
      setAllChecked(false);
    }
  }, [termsChecked, privacyChecked]);

  const [bankOptions, setBankOptions] = useState<
    { value: string; label: string }[]
  >([]);

  const emailOptions = [
    { value: 'gmail.com', label: 'gmail.com' },
    { value: 'naver.com', label: 'naver.com' },
    { value: 'daum.net', label: 'daum.net' },
    { value: 'hanmail.net', label: 'hanmail.net' },
    { value: 'yahoo.com', label: 'yahoo.com' },
    { value: 'outlook.com', label: 'outlook.com' },
    { value: 'custom', label: '직접 입력' }, // ✨ 직접 입력 추가
  ];

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    // 아이디 유효성 검증 추가
    if (name === 'identifier') {
      setIsIdentifierChecked(false);
      // 한글 포함 여부 검사 (ㄱ-ㅎ, 가-힣 범위)
      const containsKorean = /[ㄱ-ㅎ가-힣]/.test(value);
      if (containsKorean) {
        setIdentifierError({
          message: '아이디에 한글은 사용할 수 없습니다.',
          color: 'red',
        });
      } else {
        const identifierRegex = /^[a-z0-9_-]{6,20}$/;
        if (!identifierRegex.test(value)) {
          setIdentifierError({
            message:
              '아이디는 6자 이상 20자 이하의 알파벳 소문자, 숫자, -, _만 사용 가능합니다.',
            color: 'red',
          });
        } else {
          setIdentifierError({
            message: '사용 가능한 아이디입니다.',
            color: 'green',
          });
        }
      }
    }

    // 비밀번호 길이 검증
    if (name === 'password' && value.length > 0 && value.length < 8) {
      setPasswordError('비밀번호는 8자 이상이어야 합니다.');
    } else {
      setPasswordError('');
    }

    // 비밀번호 확인과 비밀번호 비교
    if (name === 'confirmPassword' || name === 'password') {
      if (name === 'confirmPassword' && value !== formData.password) {
        setPasswordMatchError('비밀번호가 일치하지 않습니다.');
      } else if (
        name === 'password' &&
        formData.confirmPassword &&
        value !== formData.confirmPassword
      ) {
        setPasswordMatchError('비밀번호가 일치하지 않습니다.');
      } else {
        setPasswordMatchError('');
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // 사용자 주소 onComplete 콜백 함수
  const handleAddressComplete = (address: string, zipCode: string) => {
    setFormData((prev) => ({
      ...prev,
      zipCode: zipCode,
      defaultAddress: address,
    }));
  };

  // 판매자 사업장 주소
  const handleSellerAddressComplete = (address: string, zipCode: string) => {
    setFormData((prev) => ({
      ...prev,
      businessZipCode: zipCode,
      businessDefaultAddress: address,
    }));
  };

  const handleIdentifierCheck = async () => {
    try {
      if (!formData.identifier) {
        alert('아이디를 입력해주세요.');
        return;
      }
      await AuthService.identifierCheck(formData.identifier);
      setIdentifierError({
        message: '사용 가능한 아이디입니다.',
        color: 'green',
      }); // 녹색 메시지 설정
      // 중복 확인 성공
      setIsIdentifierChecked(true);
    } catch (error) {
      console.error('아이디 중복 확인 실패:', error);
      const errorMessage =
        error instanceof Error
          ? error.message
          : '아이디 중복 확인 중 오류가 발생했습니다.';
      setIdentifierError({ message: errorMessage, color: 'red' });
    }
  };

  // 이메일 인증 코드 전송
  const handleSendEmailCode = async () => {
    try {
      setIsEmailLoading(true); // 로딩 시작
      const finalEmail =
        email === 'custom' && customEmail
          ? `${formData.email}@${customEmail}`
          : email
            ? `${formData.email}@${email}`
            : '';

      if (!finalEmail) {
        alert('이메일 주소를 입력해주세요.');
        setIsEmailLoading(false); // 로딩 종료
        return;
      }

      const response = await AuthService.sendEmailVerificationCode(finalEmail);
      alert(
        '이메일 인증 코드가 발송되었습니다. 이메일이 오지 않으면 스팸 메일함을 확인해주세요.'
      );
      setTargetTime(response.data);
      setIsCodeSent(true);
    } catch (error) {
      console.error('이메일 인증 코드 전송 실패:', error);
      let errorMessage = '';
      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (typeof error === 'string') {
        errorMessage = error;
      } else {
        errorMessage = '이메일 확인 중 오류가 발생했습니다.';
      }
      // "Error:"와 숫자 코드 및 콜론을 제거 (예: "400: " 또는 "Error: 400: ")
      errorMessage = errorMessage.replace(/^(Error:\s*)?\d+:\s*/, '');
      alert(errorMessage);
    } finally {
      setIsEmailLoading(false); // 로딩 종료
    }
  };

  // 이메일 인증 코드 확인
  const handleValidateEmailCode = async () => {
    const finalEmail =
      email === 'custom' && customEmail
        ? `${formData.email}@${customEmail}`
        : email
          ? `${formData.email}@${email}`
          : '';
    try {
      if (!formData.emailCode) {
        alert('인증 코드를 입력해주세요.');
        return;
      }

      await AuthService.validateEmailVerificationCode(
        finalEmail,
        formData.emailCode
      );
      alert('이메일 인증이 완료되었습니다.');
      setTargetTime('');
    } catch (error) {
      console.error('이메일 인증 실패:', error);
      let errorMessage = '';
      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (typeof error === 'string') {
        errorMessage = error;
      } else {
        errorMessage = '이메일 확인 중 오류가 발생했습니다.';
      }
      // "Error:"와 숫자 코드 및 콜론을 제거 (예: "400: " 또는 "Error: 400: ")
      errorMessage = errorMessage.replace(/^(Error:\s*)?\d+:\s*/, '');
      alert(errorMessage);
    }
  };

  //회원가입 로직
  const handleSignup = async () => {
    try {
      if (!isIdentifierChecked) {
        alert('아이디 중복 확인을 먼저 해주세요.');
        return;
      }

      // 비밀번호와 비밀번호 확인이 일치하지 않는 경우
      if (formData.password !== formData.confirmPassword) {
        alert('비밀번호가 일치하지 않습니다.');
        return;
      }

      // 이메일 처리 및 검증
      if (!email && !customEmail) {
        alert('이메일 도메인을 선택하거나 직접 입력해주세요.');
        return;
      }

      // 체크박스가 선택되지 않은 경우
      // 체크박스가 선택되지 않은 경우 확인
      if (!termsChecked || !privacyChecked) {
        alert('개인정보 수집 및 이용 동의를 체크해주세요.');
        return;
      }
      const finalEmail =
        email === 'custom' && customEmail
          ? `${formData.email}@${customEmail}`
          : email
            ? `${formData.email}@${email}`
            : '';

      if (!finalEmail.includes('@') || !formData.email) {
        alert('유효한 이메일 주소를 입력해주세요.');
        return;
      }

      if (selectedType === 'seller' && !isValidated) {
        alert('사업자 확인을 완료해주세요.');
        return;
      }

      if (!formData.emailCode) {
        alert('이메일 인증 코드를 입력해주세요.');
        return;
      }

      // 전화번호에서 '-' 제거
      const cleanedPhoneNumber = formData.phoneNumber.replace(/-/g, '');
      const cleanedBusinessNumber = formData.businessNumber.replace(/-/g, '');
      const cleanedBusinessAccountNumber =
        formData.businessAccountNumber.replace(/-/g, '');

      // 필수 값 검증
      const requiredFields = [
        { field: formData.identifier, message: '아이디를 입력해주세요.' },
        { field: formData.password, message: '비밀번호를 입력해주세요.' },
        { field: finalEmail, message: '이메일을 입력해주세요.' },
        { field: formData.phoneNumber, message: '전화번호를 입력해주세요.' },
        { field: formData.name, message: '이름을 입력해주세요.' },
        { field: formData.zipCode, message: '우편번호를 입력해주세요.' },
        { field: formData.defaultAddress, message: '주소를 입력해주세요.' },
      ];

      if (selectedType === 'seller') {
        requiredFields.push(
          {
            field: formData.businessNumber,
            message: '사업자등록번호를 입력해주세요.',
          },
          {
            field: formData.businessRepresentativeName,
            message: '대표자 이름을 입력해주세요.',
          },
          {
            field: formData.businessOpenDate,
            message: '개업일자를 입력해주세요.',
          },
          { field: formData.businessName, message: '사업장명을 입력해주세요.' },
          {
            field: formData.businessZipCode,
            message: '사업장 우편번호를 입력해주세요.',
          },
          {
            field: formData.businessDefaultAddress,
            message: '사업장 주소를 입력해주세요.',
          },
          { field: bank, message: '은행을 선택해주세요.' },
          {
            field: formData.businessAccountNumber,
            message: '계좌번호를 입력해주세요.',
          }
        );
      }

      for (const { field, message } of requiredFields) {
        if (!field || field.trim() === '') {
          alert(message);
          return;
        }
      }

      if (selectedType === 'buyer') {
        const buyerData = {
          identifier: formData.identifier,
          password: formData.password,
          email: finalEmail,
          emailCode: formData.emailCode,
          phoneNumber: cleanedPhoneNumber,
          name: formData.name,
          zipCode: formData.zipCode,
          defaultAddress: formData.defaultAddress,
          detailAddress: formData.detailAddress, // 선택 값
        };

        await AuthService.buyerSignup(buyerData);
        alert('구매자 회원가입이 완료되었습니다!');
        resetSignupForm(); // 상태 초기화
        navigate(LoginPageUrl);
      } else if (selectedType === 'seller') {
        const sellerData = {
          identifier: formData.identifier,
          password: formData.password,
          email: finalEmail,
          emailCode: formData.emailCode,
          phoneNumber: cleanedPhoneNumber,
          name: formData.name,
          zipCode: formData.zipCode,
          defaultAddress: formData.defaultAddress,
          detailAddress: formData.detailAddress, // 선택 값
          businessNumber: cleanedBusinessNumber,
          businessRepresentativeName: formData.businessRepresentativeName,
          businessOpenDate: formData.businessOpenDate,
          businessName: formData.businessName,
          businessZipCode: formData.businessZipCode,
          businessDefaultAddress: formData.businessDefaultAddress,
          businessDetailAddress: formData.businessDetailAddress, // 선택 값
          businessAccountBank: bank,
          businessAccountNumber: cleanedBusinessAccountNumber,
        };

        await AuthService.sellerSignup(sellerData);
        alert('판매자 회원가입이 완료되었습니다!');
        resetSignupForm(); // 상태 초기화
        navigate(LoginPageUrl);
      }
    } catch (error) {
      console.error('회원가입 실패:', error);
      let errorMessage = '';
      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (typeof error === 'string') {
        errorMessage = error;
      } else {
        errorMessage = '회원가입 확인 중 오류가 발생했습니다.';
      }
      // "Error:"와 숫자 코드 및 콜론을 제거 (예: "400: " 또는 "Error: 400: ")
      errorMessage = errorMessage.replace(/^(Error:\s*)?\d+:\s*/, '');
      alert(errorMessage);
    }
  };

  const handleSellerValidate = async () => {
    try {
      const { businessNumber, businessRepresentativeName, businessOpenDate } =
        formData;

      // 필수값 체크
      if (!businessNumber || !businessRepresentativeName || !businessOpenDate) {
        // console.log(
        //   businessNumber,
        //   businessRepresentativeName,
        //   businessOpenDate
        // );

        alert('사업자등록번호와 대표자 성명, 개업일자를 입력해주세요.');
        return;
      }

      const cleanedBusinessNumber = businessNumber.replace(/-/g, '');

      const validateData = {
        businessNumber: cleanedBusinessNumber,
        businessRepresentativeName: businessRepresentativeName,
        businessOpenDate: businessOpenDate,
      };

      await AuthService.sellerBusinessValidate(validateData);
      alert(`사업자 등록번호 확인 성공`);
      setIsValidated(true); // 사업자 확인 성공 시 상태 업데이트
    } catch (error) {
      let errorMessage = '';
      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (typeof error === 'string') {
        errorMessage = error;
      } else {
        errorMessage = '사업자 등록번호 확인 중 오류가 발생했습니다.';
      }
      // "Error:"와 숫자 코드 및 콜론을 제거 (예: "400: " 또는 "Error: 400: ")
      errorMessage = errorMessage.replace(/^(Error:\s*)?\d+:\s*/, '');
      alert(errorMessage);
    }
  };

  // 은행 목록 가져오기
  useEffect(() => {
    const fetchBankOptions = async () => {
      try {
        const response = await AuthService.getSellerBusinessBanks();
        const banks = response.data.map((bankName: string) => ({
          value: bankName,
          label: bankName,
        }));
        setBankOptions(banks); // 상태에 은행 목록 저장
      } catch (error) {
        console.error('은행 목록 조회 실패:', error);
      }
    };

    fetchBankOptions();
  }, []);

  return (
    <Container>
      <PermissionRedirect />
      {isEmailLoading && <LoadingOverlay />}

      <Title>회원가입</Title>
      <Form>
        <Section>
          <Row>
            <Label>구매자/판매자 관리 선택</Label>
            <CheckboxContainer>
              <Checkbox
                type="checkbox"
                checked={selectedType === 'buyer'}
                onChange={() => setSelectedType('buyer')}
              />
              <CheckboxText>매물정보(구매자)</CheckboxText>
            </CheckboxContainer>
            <CheckboxContainer>
              <Checkbox
                type="checkbox"
                checked={selectedType === 'seller'}
                onChange={() => setSelectedType('seller')}
              />
              <CheckboxText>진단정보(판매자)</CheckboxText>
            </CheckboxContainer>
          </Row>
          <Row>
            <Label>이름</Label>
            <Input
              type="text"
              placeholder="이름을 입력해주세요"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
          </Row>
          <Row>
            <Label>아이디</Label>
            <Input
              type="text"
              placeholder="아이디를 입력해주세요"
              name="identifier"
              value={formData.identifier}
              onChange={handleChange}
            />
            <Button type="button" onClick={handleIdentifierCheck}>
              중복확인
            </Button>
          </Row>
          {identifierError.message && (
            <Row
              style={{
                color: identifierError.color,
                marginTop: '5px',
                fontSize: '14px',
              }}
            >
              <Label />
              <p>
                {identifierError.message
                  .split(':')
                  .pop()
                  ?.trim()
                  .replace(';', '')}
              </p>
            </Row>
          )}
          <Row>
            <Label>비밀번호</Label>
            <Input
              type="password"
              placeholder="비밀번호를 입력해주세요"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
          </Row>
          {passwordError && (
            <Row
              style={{
                color: 'red',
              }}
            >
              <Label />
              <p>{passwordError}</p>
            </Row>
          )}
          <Row>
            <Label>비밀번호 확인</Label>
            <Input
              type="password"
              placeholder="비밀번호를 다시 입력해주세요"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
            />
          </Row>
          {passwordMatchError && (
            <Row
              style={{
                color: 'red',
              }}
            >
              <Label />
              <p>{passwordMatchError}</p>
            </Row>
          )}
          <Row>
            <Label>전화번호</Label>
            <Input
              type="text"
              placeholder="전화번호를 입력해주세요"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={(e) => {
                const formattedNumber = formatPhoneNumber(e.target.value); // 3-4-4 포맷 적용
                setFormData((prevData) => ({
                  ...prevData,
                  phoneNumber: formattedNumber,
                }));
              }}
            />
          </Row>
          <Row>
            <Label>이메일주소</Label>
            <Input
              type="text"
              placeholder="이메일을 입력해주세요"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
            <p>@</p>
            <SelectBox
              options={emailOptions}
              value={email}
              onChange={(value) => {
                setEmail(value);
                if (value !== 'custom') {
                  setCustomEmail(''); // "직접 입력"이 아니면 초기화
                }
              }}
              placeholder="도메인을 선택하세요"
            />
            {email !== 'custom' && (
              <Button type="button" onClick={handleSendEmailCode}>
                인증하기
              </Button>
            )}
            {targetTime && <CountdownTimer targetTime={targetTime} />}
          </Row>
          <Row>
            <LabelNo />
            {email === 'custom' && (
              <>
                <Input
                  type="text"
                  placeholder="도메인을 직접 입력해주세요"
                  value={customEmail}
                  onChange={(e) => setCustomEmail(e.target.value)}
                />
                <Button type="button" onClick={handleSendEmailCode}>
                  인증하기
                </Button>
              </>
            )}

            {isCodeSent && (
              <>
                <Input
                  type="text"
                  placeholder="인증번호를 입력해 주세요"
                  name="emailCode"
                  value={formData.emailCode}
                  onChange={handleChange}
                />
                <Button type="button" onClick={handleValidateEmailCode}>
                  확인
                </Button>
              </>
            )}
          </Row>

          <Row>
            <Label>주소</Label>
            <Input
              type="text"
              placeholder="주소를 입력해주세요"
              name="defaultAddress"
              value={formData.defaultAddress}
              readOnly
            />
            <KakaoAddressSearch onComplete={handleAddressComplete} />
          </Row>
          <Row>
            <LabelNo />
            <Input
              type="text"
              placeholder="우편번호"
              style={{ maxWidth: 100 }}
              readOnly
              name="zipCode"
              value={formData.zipCode}
            />
            <Input
              type="text"
              placeholder="상세 주소를 입력해주세요"
              name="detailAddress"
              value={formData.detailAddress}
              onChange={handleChange}
            />
          </Row>
          <Row>
            <Label>약관 동의</Label>
            <CheckboxContainer>
              <Checkbox
                type="checkbox"
                checked={allChecked}
                onChange={handleAllAgreementChange}
              />
              <CheckboxText>전체동의</CheckboxText>
            </CheckboxContainer>
          </Row>
          <Row>
            <LabelNo />
            <CheckboxDetail>
              <CheckboxRow>
                <CheckboxContainer>
                  <Checkbox
                    type="checkbox"
                    checked={termsChecked}
                    onChange={(e) => handleAgreementChange(e, 'terms')}
                  />
                  <CheckboxText>이용약관 동의</CheckboxText>
                </CheckboxContainer>
                <CheckboxDetailText
                  onClick={() => navigate(PrivacyInfoPageUrl)}
                >
                  전문보기
                </CheckboxDetailText>
              </CheckboxRow>
              <CheckboxRow>
                <CheckboxContainer>
                  <Checkbox
                    type="checkbox"
                    checked={privacyChecked}
                    onChange={(e) => handleAgreementChange(e, 'privacy')}
                  />
                  <CheckboxText>개인정보 수집 · 이용 동의</CheckboxText>
                </CheckboxContainer>
                <CheckboxDetailText
                  onClick={() => navigate(PrivacyPolicyPageUrl)}
                >
                  전문보기
                </CheckboxDetailText>
              </CheckboxRow>
            </CheckboxDetail>
          </Row>
        </Section>

        {selectedType === 'seller' && (
          <Section>
            <SectionTitleContainer>
              <Line />
              <StyledSectionTitle>진단정보(판매자)만 입력</StyledSectionTitle>
              <Line />
            </SectionTitleContainer>
            <RowContainer>
              <RowBox>
                <Row>
                  <Label>사업자등록번호</Label>
                  <Input
                    type="text"
                    placeholder="사업자등록번호를 입력해주세요"
                    name="businessNumber"
                    value={formData.businessNumber}
                    onChange={(e) => {
                      const formattedNumber = formatBusinessNumber(
                        e.target.value
                      );
                      setFormData((prevData) => ({
                        ...prevData,
                        businessNumber: formattedNumber,
                      }));
                    }}
                  />
                  <LabelSecond>대표자 성명</LabelSecond>
                  <Input
                    type="text"
                    placeholder="대표자 성명을 입력해주세요"
                    name="businessRepresentativeName"
                    value={formData.businessRepresentativeName}
                    onChange={handleChange}
                  />
                </Row>
                <Row>
                  <Label>사업장명</Label>
                  <Input
                    type="text"
                    placeholder="사업장명을 입력해주세요"
                    name="businessName"
                    value={formData.businessName}
                    onChange={handleChange}
                  />
                  <LabelSecond>개업일자</LabelSecond>
                  <Input
                    type="date"
                    placeholder="개업일자를 입력해주세요"
                    name="businessOpenDate"
                    value={formData.businessOpenDate}
                    onChange={handleChange}
                  />
                  <ButtonM type="button" onClick={handleSellerValidate}>
                    사업자 확인
                  </ButtonM>
                </Row>
              </RowBox>
              <ButtonP type="button" onClick={handleSellerValidate}>
                사업자 확인
              </ButtonP>
            </RowContainer>
            <Row>
              <Label>사업장 주소</Label>
              <Input
                type="text"
                placeholder="주소를 입력해주세요"
                name="businessDefaultAddress"
                value={formData.businessDefaultAddress}
                readOnly
              />
              <KakaoAddressSearch onComplete={handleSellerAddressComplete} />
            </Row>
            <Row>
              <LabelNo />
              <Input
                type="text"
                placeholder="우편번호"
                style={{ maxWidth: 100 }}
                readOnly
                name="businessZipCode"
                value={formData.businessZipCode}
              />
              <Input
                type="text"
                placeholder="상세 주소를 입력해주세요"
                name="businessDetailAddress"
                value={formData.businessDetailAddress}
                onChange={handleChange}
              />
            </Row>
            <Row>
              <Label>계좌번호</Label>
              <SelectBox
                options={bankOptions}
                value={bank}
                onChange={setBank}
                placeholder="은행을 선택하세요"
              />
              <Input
                type="text"
                placeholder="계좌번호를 입력해주세요"
                name="businessAccountNumber"
                value={formData.businessAccountNumber}
                onChange={(e) => {
                  const formattedNumber = formatAccountNumber(e.target.value);
                  setFormData((prevData) => ({
                    ...prevData,
                    businessAccountNumber: formattedNumber,
                  }));
                }}
              />
              {/* <Button type="button">계좌 확인</Button> */}
            </Row>
          </Section>
        )}

        <SiginUpButton type="button" onClick={handleSignup}>
          회원가입하기
        </SiginUpButton>
      </Form>
    </Container>
  );
};

export default SignupPage;
